import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=18b107c0&scoped=true&"
import script from "./Warehouse.vue?vue&type=script&lang=js&"
export * from "./Warehouse.vue?vue&type=script&lang=js&"
import style0 from "./Warehouse.vue?vue&type=style&index=0&id=18b107c0&prod&lang=css&"
import style1 from "./Warehouse.vue?vue&type=style&index=1&id=18b107c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b107c0",
  null
  
)

export default component.exports